import { Routes, Route } from "react-router-dom";
import { useDispatch } from "react-redux";

import MainLayout from "./components/MainLayout";
import Home from "./components/Home";
import AllProducts from "./components/AllProducts";
import Clothing from "./components/Clothing";
import Jewelery from "./components/Jewelery";
import Electronics from "./components/Electronics";
import Details from "./components/Details";
import Cart from "./components/Cart";

import { storeProducts } from "./apis/productsApiSlice";
import { storeCarts } from "./apis/cartsApiSlice";

const App = () => {
  const dispatch = useDispatch();

  fetch("https://fakestoreapi.com/products")
    .then((res) => res.json())
    .then((json) => dispatch(storeProducts(json)));
  fetch("https://fakestoreapi.com/carts")
    .then((res) => res.json())
    .then((json) => {
      if (json[0]?.products?.length) {
        dispatch(storeCarts(json[0].products))
      }
    });

  return (
    <>
      <Routes>
        <Route path="/" element={<MainLayout />}>
          <Route index element={<Home />} />
          <Route path="all_products">
            <Route
              index
              element={<AllProducts title={"All Products"} category={""} />}
            />
            <Route path=":id" element={<Details />} />
          </Route>
          <Route
            path="clothing"
            element={<Clothing title={"Clothing"} category={"clothing"} />}
          />
          <Route
            path="jewelery"
            element={<Jewelery title={"Jewelery"} category={"jewelery"} />}
          />
          <Route
            path="electronics"
            element={
              <Electronics title={"Electronics"} category={"electronics"} />
            }
          />
          <Route
            path="cart"
            element={
              <Cart />
            }
          />
        </Route>
      </Routes>
    </>
  );
};

export default App;
